import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { AccessService } from 'features/settings/features/access/service/service'

export { AccessService } from 'features/settings/features/access/service/service'

export function useAccessService(): AccessService {
  const client = useApiClient()

  if (!client) {
    throw new Error('useAccessService must be used within ApiClientProvider')
  }

  return useMemo(() => new AccessService(client), [client])
}
